import classNames from 'classnames'
import React, { FC } from 'react'
import { css } from '@emotion/react'
import { useLooopTheme } from '../../../../public-api/hooks/useLooopTheme'

import IconClose from '../../icon/IconClose'
import IconMagnifier from '../../icon/IconMagnifier'
import Input, { InputProps } from './Input'
import InputWrapper from './InputWrapper'
import { Box } from 'front-end/src/components'

import './ResettableInput.less'
import { brandColors } from 'shared/basicPalette'

export const ResettableInput: FC<
  InputProps & {
    onReset: () => void
    showResetButton: boolean
    showSearchIcon?: boolean
  }
> = (props) => {
  const { theme } = useLooopTheme()
  const { onReset, showResetButton, showSearchIcon, ...inputProps } = props
  const wrapperClassNames = classNames('ResettableInput', {
    'ResettableInput--Search': props.showSearchIcon
  })
  return (
    <InputWrapper className={wrapperClassNames}>
      {props.showSearchIcon && <IconMagnifier />}
      <Box
        css={css`
          input {
            &:active,
            &:focus {
              border-color: ${theme.colors.buttonPrimary.default};
            }
            &::placeholder {
              color: ${brandColors.greyTransparent[50]};
            }
          }
        `}
      >
        <Input {...inputProps} />
      </Box>
      {props.showResetButton && <IconClose onClick={props.onReset} />}
    </InputWrapper>
  )
}
export default ResettableInput
